<template>
    <div>
        <multiselect
            v-model="buyingUserFilter"
            selectLabel="Нажмите для добавления"
            deselectLabel="Нажмите для удаления"
            selectedLabel="Выбрано"
            placeholder="Вы можете добавить один или несколько пользовательских статусов"
            label="value"
            track-by="name"
            :options="buyingFilter"
            :multiple="true"
            :searchable="false"
            @input="onChange"
        ></multiselect>
    </div>
</template>

<script>

    import 'vue-multiselect/dist/vue-multiselect.min.css';
    import Multiselect from 'vue-multiselect'
    import Buying from "../services/BuyingService";

    Vue.component('multiselect', Multiselect);

    const COMPONENT_NAME = "buying-filter";

    export default {
        name: COMPONENT_NAME,
        components: {
            'multiselect': Multiselect,
        },
        props: ['buyingId'],
        data() {
            return {
                buyingFilter: [],
                buyingUserFilter: [],
            };
        },
        mounted() {
            this.getBuyingFilter();
        },
        methods: {
            async getBuyingFilter() {
                try {
                    let response = await Buying.getBuyingUserFilter(this.buyingId);
                    if (response.success) {
                        this.buyingFilter = response.data.buyingFilterStructure;
                        this.buyingUserFilter = response.data.buyingUserFilter;
                    }
                } catch (e) {
                    console.error(e);
                }
            },
            async onChange (value) {
                let response = await Buying.setBuyingUserFilter(this.buyingId, value);
                if (response.success) {
                    this.$message('Фильтр обновлён');
                }else{
                    this.$message('Произошла ошибка');
                }
            },
        }
    }
</script>

<style lang="scss" scoped>

</style>